/** @flow */

import {
  GetDynamicQuestions,
  GetDynamicQuestionsSuccess,
  GetDynamicQuestionsError,
  GetDynamicQuestion,
  GetDynamicQuestionSuccess,
  GetDynamicQuestionError,
  NewDynamicQuestion,
  SetShowAddDynamicQuestionModal,
  UpdateDynamicQuestionDraft,
  SetDynamicQuestionRevisionSchema,
  SetDynamicQuestionAssignments,
  ShowDynamicQuestionEditModal,
  UpdateDynamicQuestionAssignmentsError,
  ShowEditDynamicQuestionAssignmentsModal,
  SetDynamicQuestionDraftAssignments,
  UpdateDynamicQuestion,
  UpdateDynamicQuestionSuccess,
  UpdateDynamicQuestionError,
  AddNewDynamicQuestion,
  AddNewDynamicQuestionSuccess,
  AddNewDynamicQuestionError,
} from "@modules/service/constants/actions";
import * as dynamicQuestionsReducers from "./reducers";
import initialState from "./state";
import type { DynamicQuestionsState } from "./types";
import { cloneObject } from "@utils/object";

export default (
  state: DynamicQuestionsState = initialState,
  action: Object,
): DynamicQuestionsState => {
  const act = {
    [AddNewDynamicQuestion]: dynamicQuestionsReducers.onAddNewDynamicQuestion,
    [AddNewDynamicQuestionSuccess]: dynamicQuestionsReducers.onAddNewDynamicQuestionSuccess,
    [AddNewDynamicQuestionError]: dynamicQuestionsReducers.onAddNewDynamicQuestionError,
    [UpdateDynamicQuestion]: dynamicQuestionsReducers.onUpdateDynamicQuestion,
    [UpdateDynamicQuestionSuccess]: dynamicQuestionsReducers.onUpdateDynamicQuestionSuccess,
    [UpdateDynamicQuestionError]: dynamicQuestionsReducers.onUpdateDynamicQuestionError,
    [GetDynamicQuestions]: dynamicQuestionsReducers.onGetDynamicQuestions,
    [GetDynamicQuestionsSuccess]: dynamicQuestionsReducers.onGetDynamicQuestionsSuccess,
    [GetDynamicQuestionsError]: dynamicQuestionsReducers.onGetDynamicQuestionsError,
    [NewDynamicQuestion]: dynamicQuestionsReducers.onNewDynamicQuestion,
    [SetShowAddDynamicQuestionModal]: dynamicQuestionsReducers.onSetShowAddDynamicQuestionModal,
    [UpdateDynamicQuestionDraft]: dynamicQuestionsReducers.onUpdateDynamicQuestionDraft,
    [SetDynamicQuestionRevisionSchema]: dynamicQuestionsReducers.onSetDynamicQuestionRevisionSchema,
    [SetDynamicQuestionAssignments]: dynamicQuestionsReducers.onSetDynamicQuestionAssignments,
    [SetDynamicQuestionDraftAssignments]:
      dynamicQuestionsReducers.onSetDynamicQuestionDraftAssignments,

    [GetDynamicQuestion]: dynamicQuestionsReducers.onGetDynamicQuestion,
    [GetDynamicQuestionSuccess]: dynamicQuestionsReducers.onGetDynamicQuestionSuccess,
    [GetDynamicQuestionError]: dynamicQuestionsReducers.onGetDynamicQuestionError,
    [ShowDynamicQuestionEditModal]: dynamicQuestionsReducers.onShowDynamicQuestionEditModal,
    [UpdateDynamicQuestionAssignmentsError]:
      dynamicQuestionsReducers.onUpdateDynamicQuestionAssignmentsError,
    [ShowEditDynamicQuestionAssignmentsModal]:
      dynamicQuestionsReducers.onShowEditDynamicQuestionAssignmentsModal,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
